import { insertBetween } from "@/utils/array";
import type { Calc } from "../../types";
import styles from "./CalculatorMessage.module.css";

export const CalculatorMessage: React.FC<Calc.Content.MessagePart> = ({
  item: parts,
}) => {
  const tokens = insertBetween<Calc.Content.TextPart>(parts, () => {
    return {
      type: "text",
      item: " ",
    };
  });

  return (
    <div className={styles.text}>
      {tokens.map((token, index) => (
        <span key={index} className={styles[token.type]}>
          {token.item}
        </span>
      ))}
    </div>
  );
};
